module.exports = "/img/quote-bg.b26bae94.jpg";